/* Wishlist. Saved in the visitor's own browser, so it needs no app and no login.
   Any element with data-wish (plus data-handle, data-title, data-url, data-image, data-price) toggles a frame;
   data-wish-open opens the list; data-wish-count shows how many are saved. */
(function () {
  'use strict';
  var KEY = 'il_wishlist';
  var read = function () { try { return JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) { return []; } };
  var write = function (list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var dialog = document.querySelector('[data-wish-dialog]');

  var render = function () {
    var list = read();
    document.querySelectorAll('[data-wish]').forEach(function (b) {
      var on = list.some(function (i) { return i.handle === b.getAttribute('data-handle'); });
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = b.querySelector('[data-wish-label]');
      if (label) label.textContent = on ? 'Saved to wishlist' : 'Add to wishlist';
      b.setAttribute('aria-label', (on ? 'Remove ' : 'Save ') + (b.getAttribute('data-title') || 'this frame') + (on ? ' from wishlist' : ' to wishlist'));
    });
    document.querySelectorAll('[data-wish-count]').forEach(function (c) { c.textContent = list.length; });
    if (!dialog) return;
    var box = dialog.querySelector('[data-wish-list]'), empty = dialog.querySelector('[data-wish-empty]');
    if (empty) empty.hidden = list.length > 0;
    if (box) box.innerHTML = list.map(function (i) {
      return '<li><a class="wl-ph" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(i.image) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="wl-tx"><a href="' + esc(i.url) + '" class="wl-name">' + esc(i.title) + '</a><span class="wl-price">' + esc(i.price) + '</span>' +
        '<span class="wl-act"><a href="' + esc(i.url) + '">View frame</a><button type="button" data-wish-remove="' + esc(i.handle) + '">Remove</button></span></div></li>';
    }).join('');
  };

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-wish]') : null;
    if (t) {
      e.preventDefault(); e.stopPropagation();
      var list = read(), h = t.getAttribute('data-handle');
      var at = -1; list.forEach(function (i, k) { if (i.handle === h) at = k; });
      if (at > -1) list.splice(at, 1);
      else list.push({ handle: h, title: t.getAttribute('data-title'), url: t.getAttribute('data-url'), image: t.getAttribute('data-image'), price: t.getAttribute('data-price') });
      write(list); render(); return;
    }
    var r = e.target.closest ? e.target.closest('[data-wish-remove]') : null;
    if (r) { write(read().filter(function (i) { return i.handle !== r.getAttribute('data-wish-remove'); })); render(); return; }
    var o = e.target.closest ? e.target.closest('[data-wish-open]') : null;
    if (o && dialog && dialog.showModal) { e.preventDefault(); render(); dialog.showModal(); return; }
    if (dialog && (e.target === dialog || (e.target.closest && e.target.closest('[data-wish-close]')))) dialog.close();
  });
  window.addEventListener('storage', function (e) { if (e.key === KEY) render(); });
  render();
})();
